import React from "react";

function SchedaProdottoPSlingua({prod, lang}) {
    
    if (prod !== "no data") {
       

        return (
            <div className="w-30 pa2">
                <h1 className="pb2 bb bordoColAlt">{lang}</h1>
                { prod?.shortName?.[lang] && <p className="pb2 bb bordoColAlt" dangerouslySetInnerHTML={{ __html: prod.shortName[lang] }}></p>}
                { prod?.descrizioniSuPS?.titolo?.[lang] && <p className="pb2 bb bordoColAlt" dangerouslySetInnerHTML={{ __html: prod.descrizioniSuPS.titolo[lang] }}></p>}
                { prod?.descrizioniSuPS?.descBreve?.[lang] && <p className="pb2 bb bordoColAlt" dangerouslySetInnerHTML={{ __html: prod.descrizioniSuPS.descBreve[lang] }}></p>}
                { prod?.descrizioniSuPS?.descLunga?.[lang] && <p className="pb2 bb bordoColAlt" dangerouslySetInnerHTML={{ __html: prod.descrizioniSuPS.descLunga[lang] }}></p>}
                
            </div>
        );
    } else {
        return (
            <p>Nessun prodotto selezionato</p>
        );
    }

}

export default SchedaProdottoPSlingua;